// Import model
import { CreateBomKitRequest } from '../models/CreateBomKitRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreateBomKitRequest - handles JSON serialization and deserialization with type validation
 */
export class CreateBomKitRequestSerializer {
  /**
   * Deserializes a JSON string into a CreateBomKitRequest instance
   */
  static deserialize(json: string): CreateBomKitRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreateBomKitRequest instance
   */
  static fromObject(obj: any): CreateBomKitRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreateBomKitRequest');
    }


    const instance: CreateBomKitRequest = {
      isActive: obj['isActive'] as boolean | undefined,
      parentObjectId: obj['parentObjectId'] as string | undefined,
      parentObjectType: obj['parentObjectType'] as string | undefined,
      tags: obj['tags'] ? (obj['tags'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      bins: obj['bins'] ? (obj['bins'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      description: obj['description'] as string | undefined,
      name: obj['name'] as string,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreateBomKitRequest instances
   */
  static deserializeArray(json: string): CreateBomKitRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreateBomKitRequest instance to a JSON string
   */
  static serialize(instance: CreateBomKitRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreateBomKitRequest instance to a plain object
   */
  static toObject(instance: CreateBomKitRequest): any {
    return {
      'isActive': instance.isActive,
      'parentObjectId': instance.parentObjectId,
      'parentObjectType': instance.parentObjectType,
      'tags': instance.tags?.map((item: any) =>
        item
      ),
      'bins': instance.bins?.map((item: any) =>
        item
      ),
      'description': instance.description,
      'name': instance.name,
    };
  }

  /**
   * Serializes an array of CreateBomKitRequest instances to a JSON string
   */
  static serializeArray(instances: CreateBomKitRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
